import './version.scss';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { BrandContext } from 'brands';

const AppVersion = import.meta.env.VITE_VERSION;

const Version = ({ className = '' }) => {
    const { name } = useContext(BrandContext);
    return (
        <div
            className={`ver ${className}`}
        >
            {name} v. {AppVersion}
        </div>
    );
};

Version.propTypes = {
    className: PropTypes.string
};

export { Version, AppVersion };
